<template>
    <div class="chart-wrap">
        <div class="chart" ref="chart" v-show="!isEmpty"></div>
        <no-result v-show="isEmpty"></no-result>
    </div>
</template>

<script>
    import NoResult from '../../../components/common/NoResult'
    import '@/common/js/common-plugins';

    const option = {
        title : {
            text: '总交易笔数',
            // subtext: '纯属虚构',a
            x:'center'
        },
        tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c}笔 ({d}%)"
        },
        toolbox: {
            feature: {
                saveAsImage: {show: true,pixelRatio:2,name:'交易笔数占比' +   new Date().format('yyyyMMddHHmmss')}
            },
            right:20
        },
        // legend: {
        //     orient: 'vertical',
        //     left: 'left',
        //     data: ['直接访问','邮件营销','联盟广告','视频广告','搜索引擎']
        // },
        series : [
            {
                name: '交易笔数占比',
                type: 'pie',
                radius : '55%',
                center: ['48%', '50%'],
                // label: {
                //     formatter: '{b}: ({d}%)'
                // },
                data:[],
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                },
                color:['#079ADE','#FF6867','#FFAE2E']
            }
        ]
    };


    export default {
        name: "TranTotalChart",
        components: {
            NoResult
        },
        data() {
            return {
                isEmpty: false,
            };
        },
        props:{
            params:{
                type:Object,
                default:() => {},
            }
        },
        mounted() {
            this.init(); // 初始化图表
            // this.getData(this.params); //获取图表所需数据
        },
        watch:{
            params(newVal,oldVal){
                if (newVal) {
                    this.getData(newVal); //获取图表所需数据
                } else {
                    this.getData(oldVal); //获取图表所需数据
                }
            },
        },
        methods: {
            init() {
                this.charts = this.$echarts.init(this.$refs.chart);
                this.charts.setOption(option);
            },
            getData(params){
                if (params.total == 0) {
                    this.isEmpty = true;
                } else {
                    this.isEmpty = false;
                }
                this.charts.setOption(option);
                this.formatData(params); // 图表数据
            },
            formatData(data) {

                this.charts.setOption({
                    series: {
                        data: [
                            {value:data.quickTotal, name:'快捷收款'},
                            {value:data.perfTotal, name:'完美还款'},
                            {value:data.fastTotal, name:'极速还款'},
                        ]
                    },
                    title: {
                        text: '总交易笔数：' + data.total + '笔'
                    },
                });
            },

        }
    };

</script>

<style scoped>
    .chart-wrap{
        width: 100%;
        height: 350px;
    }
    .chart{
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/view/fragment/echarts/TranTotalChart.vue